// extracted by mini-css-extract-plugin
export default {"link":"gK-z","disabled":"hK-z"};